<!-- =========================================================================================
    File Name: VxTour.vue
    Description: Tour Component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <v-tour v-show='show' :callbacks='callbacks' name="vuexyTour" :steps="steps">
      <template slot-scope="tour">
          <transition name="fade">
            <template v-for="(step, index) of tour.steps">
              <vx-tour-step v-if="tour.currentStep === index" :tour='tour' :key='index' :step=step></vx-tour-step>
            </template>
          </transition>
      </template>
    </v-tour>
</template>

<script>
import { mapGetters } from 'vuex';
const VxTourStep = () => import('@/components/VxTourStep.vue')

export default{
    name: 'vx-tour',
    components: {VxTourStep},
    props: {
      steps: {
        required: true,
        type: Array
      },
      callbacks: {
        required: false,
        type: Object
      }
    },
    computed: {
      show() {
        return this.$store.state.tour.visible
      }
    },
    watch: {
      '$route.path'() {
        this.$store.commit('SET_TOUR_VISIBILITY',false);
        // this.$tours['vuexyTour'].stop()
      }
    },
    mounted() {
      this.$tours['vuexyTour'].start()
    }
}
</script>

<style lang="scss">
.v-tour {
    .v-step {
        z-index: 55000;
        background-color: rgba(var(--vs-primary),1);
        border-radius: .5rem;
        padding: 1.5rem;
        filter: drop-shadow(0 0 7px rgba(0,0,0,.5));

        .v-step__arrow {
            border-color: rgba(var(--vs-primary),1);
        }

        .vs-button-border:not(.btn-tour-next):not(.btn-tour-finish) {
            border-color: rgba(255, 255, 255, .5) !important;
        }
    }
}
</style>
